import { useLocation } from 'react-router-dom';
import { useState } from 'react';
// CANDIDATO ALLA DISTRUZIONE DOPO REFACTORING DI USE SETTINGS CONTEXT
const useFiltersFromLocation = (defaultparams = {}) => {
    const location = useLocation();

    const isValidJSON = (data) => {
        if (typeof data === 'object' && data !== null) return true;
        if (typeof data !== 'string') return false;

        try {
            const parsed = JSON.parse(data);
            return typeof parsed === 'object' && parsed !== null;
        } catch (e) {
            return false;
        }
    };

    const [filters, setFilters] = useState(() => {
        const locationparams = new URLSearchParams(location.search);
        const params = {
            ...defaultparams,
            ...Object.fromEntries(locationparams)
        };

        console.info('useFiltersFromLocation aa', params);
        if (params.size === 0) return;

        const newFilters = { items: [] };
        Object.entries(params).forEach(([field, value]) => {
            const isJSON = isValidJSON(value);

            if (isJSON) {
                let v = value
                if (typeof v === 'string') {
                    v = JSON.parse(value);
                }

                let operator = 'betweenNumbers'

                if (typeof v?.from !== 'number') {
                    operator = 'between'
                }

                newFilters.items.push({
                    field,
                    operator: operator,
                    value: v,
                });
            } else if (value == 'null' || value == 'missing' || value == '_') {
                newFilters.items.push({
                    field,
                    operator: 'isEmpty',
                    value,
                });
            } else if (
                [
                    '_related_legalEntity_commercialCluster',
                    '_related_renter_name',
                    '_related_area_name',
                    '_related_shop_name',
                    '_related_agent_fullname',
                    '_related_source_name'
                ].includes(field)
            ) { // campi che devono avere equals
                newFilters.items.push({
                    field,
                    operator: 'equals',
                    value,
                });
            } else {
                newFilters.items.push({
                    field,
                    operator: 'contains',
                    value,
                });
            }
        });

        return newFilters;
    });

    return [filters, setFilters];
};

export default useFiltersFromLocation;
